<script setup lang="ts">
import { onMounted, useTemplateRef } from 'vue'
import { TimerOrientation, TimerProgression, useIdleTimer } from '@nsftx/seven-nxg-retail-vue-sdk'
import { NXGRetailTimerBar } from '@nsftx/seven-nxg-retail-vue-sdk/ui'
import { useIdleWarningModalStore } from '@/stores/idleWarningModal/idleWarningModalStore'
import { useOnIdleTimerEnd } from '@/composables/useOnIdleTimerEnd/useOnIdleTimerEnd'

const timerRef = useTemplateRef('timerRef')
const idleWarningModalStore = useIdleWarningModalStore()
const { onIdleTimerEnd } = useOnIdleTimerEnd()

const idleTime = 120_000
const transitionDelay = 5_000
const idleWarningModalDelay = 5_000
const timerPosition = {
  left: 0,
  bottom: 0
}

const onTimerReset = () => {
  timerRef.value?.resetTimerAnimation()
  idleWarningModalStore.setShowWarningModal(false)
}

const onTimerTick = (tick: number) => {
  if (tick === idleWarningModalDelay) idleWarningModalStore.setShowWarningModal(true)
}

const idleTimer = useIdleTimer({
  duration: idleTime,
  transitionDelay,
  onEnd: onIdleTimerEnd,
  onReset: onTimerReset,
  onTick: onTimerTick
})

onMounted(() => {
  idleTimer.startIdleTimer()
})
</script>

<template>
  <div class="timer-bar">
    <NXGRetailTimerBar
      ref="timerRef"
      height="56px"
      :duration="idleTime"
      :transition-delay="transitionDelay"
      bg-color="var(--st-idle-bar-bg-color)"
      loading-bar-color="var(--nxgds-mapped-color-surface-brand)"
      :orientation="TimerOrientation.Vertical"
      :progression-style="TimerProgression.DESC"
      :position="timerPosition"
    />
  </div>
</template>

<style lang="scss">
.timer-bar {
  position: relative;
  height: 56px;
  width: 6px;
  --st-idle-bar-bg-color: rgba(from var(--nxgds-mapped-color-surface-brand) r g b / 0.2);
}
</style>
